<template>
  <div>
    <div class="pxkeji-right-box">
      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="名称">
              <a-input placeholder="请输入" v-model="where.keyword.name" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-button type="primary" @click="searchList">搜索</a-button>
            <!-- <a-button :style="{ marginLeft: '8px' }" @click="clear">清空</a-button> -->
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="pxkeji-right-box">
      <a-table
        :columns="list.columns"
        rowKey="id"
        :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows}"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :locale="{emptyText:'暂无数据'}"
      >
        <span slot="img" slot-scope="img">
          <img :src="img" width="40"/>
        </span>
        <span slot="status" slot-scope="status">
          <a-tag v-if="status" color="green">启用</a-tag>
          <a-tag v-else color="red">禁用</a-tag>
        </span>
      </a-table>
    </div>
    <a-row :gutter="24">
      <a-col :span="24" :style="{ textAlign: 'center' }">
        <a-button type="primary" @click="choseBack">选择并返回</a-button>
      </a-col>
    </a-row>
  </div>
</template>
<script>
var that;

const columns = [
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "编号"
  },
  {
    dataIndex: "name",
    key: "name",
    align: "center",
    title: "服务项目名称"
  },
  {
    dataIndex: "img",
    key: "img",
    align: "center",
    title: "图标",
    scopedSlots: { customRender: "img" }
  },
  {
    dataIndex: "addTime",
    key: "addTime",
    align: "center",
    title: "创建时间"
  },
  {
    dataIndex: "creatorName",
    key: "creatorName",
    align: "center",
    title: "创建人"
  },
  {
    dataIndex: "status",
    key: "status",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "status" }
  }
];

export default {
  props: {
    ids: Array
  },
  name: "userlist",
  data() {
    return {
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          name: "",
          parentName: ""
        }
      },
      selectRows: [], //选中项编号
      selectData: [], //选中项
      isloading: false,
      addedit: {
        //编辑
        visible: false,
        id: 0,
        title: "",
        type: 0
      },
      visibleSupply: false //弹框
    };
  },
  components: {},
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      this.GetList();
      if (this.ids.length>0) this.selectRows = this.ids;
    });
  },
  watch: {
    selectRows: function() {
      //console.log("watch", val);
    }
  },
  methods: {
    toggle() {
      this.expand = !this.expand;
    },
    GetList() {
      //获取列表
      this.isloading = true;
      this.clearRows();
      this.$api.cms.articlecategory
        .page(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          this.where.keyword.name,
          '服务',
          1
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = res.data.total;
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys, selectedRows) {
      //table 单选
      this.selectRows = selectedRowKeys;
      this.selectData = selectedRows;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    //日期选择
    timeonChange(date, dateString) {
      this.where.keyword.startDate = dateString[0];
      this.where.keyword.endDate = dateString[1];
    },
    //查看订单
    showInfo(id, num) {
      this.addedit.visible = true;
      this.addedit.id = id;
      this.addedit.type = num;
      this.addedit.title = num ? "编辑" : "查看";
    },
    /**导出 */
    exportList() {},
    //子组件传值
    save() {
      this.addedit.visible = false;
      this.GetList();
    },
    close() {
      this.$confirm({
        title: "提示",
        content: "您确定要禁用么",
        okText: "确认",
        cancelText: "取消"
      });
    },
    //选择并返回
    choseBack() {
      if (this.selectRows.length > 0) {
        this.$emit("callbackMethod", this.selectData);
      } else {
        this.$message.error("请选择服务项目!");
        return;
      }
    }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}

.cang_sta {
  text-align: center;
}

.cang_sta img {
  width: 35px;
}
</style>

